import { Suspense } from 'react';
import { loadable } from '@direct-frontend/modules-render';
import { getSafeUserRequestContext } from '#shared/lib/context';
import { withDeferred } from '#shared/lib/hocs';

/** Чанк создаётся один раз на уровне модуля */
const FlagControllerLazy = loadable(() => import(/* webpackChunkName: "FlagController" */ './FlagController'));

/**
 * isInternalYandexUser-guard вынесен ВЫШЕ loadable: чтобы для внешних пользователей чанк не запрашивался вообще.
 * @kind helper
 */
function FlagControllerLoadable() {
    const { isInternalYandexUser } = getSafeUserRequestContext();

    if (!isInternalYandexUser) {
        return null;
    }

    return (
        <Suspense fallback={null}>
            <FlagControllerLazy />
        </Suspense>
    );
}

/**
 * withDeferred откладывает монтирование до requestIdleCallback
 * @kind helper
 */
export const FlagControllerAsync = withDeferred(FlagControllerLoadable);
